/// <amd-module name="typeahead/features/UitkDropDownGeometryReplicatorForMercury" />

/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/thirdparty/jquery/jquery.d.ts" />

import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IDropDownShowHandler} from "typeahead/core/presentation/IDropDownShowHandler";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [{}];

export class UitkDropDownGeometryReplicatorForMercury implements IDropDownShowHandler<undefined> {
    private static applicableClients: string[] = [
        "Homepage",
        "AWSHomepage",
        "LXLandingPage",
        "CarsLandingPage",
        "FlightsLandingPage",
        "HotelsLandingPage",
        "PackageLandingPage",
        "RailsLandingPage"];
    // @baseSpacingHorz as defined in uitoolkit; see uitoolkit/.../mixins.less (http://go/iuo39gal)
    private static baseSpacingHorz: number = 12;
    private static uitkTypeaheadWidthPx = 600;
    private static uitkTypeaheadMinWidthPx = 282;
    private static resizeEventTypes: string = "orientationchange resize";

    private static optimizeDropDownGeometry($dropDownElement: JQuery, $inputElement: JQuery): void {
        const availableMediaWidthPx: number =
            4 + document.body.clientWidth - UitkDropDownGeometryReplicatorForMercury.baseSpacingHorz * 2;
        const minDropDownWidthPx: number =
            4 + Math.min(UitkDropDownGeometryReplicatorForMercury.uitkTypeaheadMinWidthPx, availableMediaWidthPx);
        const maxDropDownWidthPx: number =
            4 + Math.min(UitkDropDownGeometryReplicatorForMercury.uitkTypeaheadWidthPx, availableMediaWidthPx);
        const newWidth: number = Math.min(maxDropDownWidthPx, availableMediaWidthPx);
        let leftOffset: number = $inputElement.offset().left - 2;
        if (leftOffset + newWidth > availableMediaWidthPx) {
            leftOffset = UitkDropDownGeometryReplicatorForMercury.baseSpacingHorz
                + availableMediaWidthPx - newWidth - 2;
            // 2px: The border of the autocomplete-dropdown is 2px narrower than that of the input
        }
        leftOffset = leftOffset - $inputElement.get(0).getBoundingClientRect().left;

        UitkDropDownGeometryReplicatorForMercury.applyDropDownGeometry(
            $dropDownElement, leftOffset, maxDropDownWidthPx, minDropDownWidthPx, newWidth);
    }

    private static applyDropDownGeometry(
        $dropDownElement: JQuery, leftOffset, maxDropDownWidthPx, minDropDownWidthPx, newWidth): void {
        $dropDownElement.css({
            "left": leftOffset + "px",
            "max-width": maxDropDownWidthPx + "px",
            "min-width": minDropDownWidthPx + "px",
            "width": newWidth + "px",
        });
    }

    private showHandlers: {[inputElementId: string]: (event: JQueryEventObject) => any} = {};

    public handleDropDownShow($dropDownElement: JQuery, $inputElement: JQuery, context: IContext):
    JQueryPromise<undefined> {
        const def: JQueryDeferred<undefined> = $.Deferred();
        if (UitkDropDownGeometryReplicatorForMercury.applicableClients.indexOf(context.clientId) >= 0) {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((result: boolean): void => {
                    if (result) {
                        this.doHandleDropDownShow($dropDownElement, $inputElement);
                    }
                    def.resolve(undefined);
                })
                .fail((): void => {
                    def.resolve(undefined);
                });
        } else {
            def.resolve(undefined);
        }
        return def.promise();
    }

    private doHandleDropDownShow($dropDownElement: JQuery, $inputElement: JQuery): void {
        const optimizeDropDownGeometry = (event: JQueryEventObject): any => {
            UitkDropDownGeometryReplicatorForMercury.optimizeDropDownGeometry($dropDownElement, $inputElement);
        };
        optimizeDropDownGeometry(null);
        $(window).on(UitkDropDownGeometryReplicatorForMercury.resizeEventTypes, null, null, optimizeDropDownGeometry);
        const inputElementId: string = $inputElement.attr("id");
        if (inputElementId) {
            this.showHandlers[$inputElement.attr("id")] = optimizeDropDownGeometry;
        }
    }
}
